import { Component, EventEmitter, Output } from '@angular/core';
import { LanguageService } from '../../../core/services/language.service';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PageListService } from '../../../core/services/page-list.service';
import { PageCommonList } from '../../../core/models/page.model';

@Component({
  selector: 'app-sidebar',
  imports: [CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.css'
})
export class SidebarComponent {
  @Output() showSidebarChange = new EventEmitter<boolean>();
  public currentUrl = '';
  showSidebar = false;
  currentLang:  'TH' | 'EN' = 'TH'

  sidebarList : PageCommonList[] | null = null;

  isOpenCategory : {category : string, open : boolean}[] = [{category : 'Home', open : true}];

  constructor( 
    languageService: LanguageService , 
    private router: Router,
    private page : PageListService
  ){  
    languageService.currentLang$.subscribe(lang => {
      this.currentLang = lang;
    });
    this.getURL();
  }
  ngOnInit(): void {
    // เช็ค URL ทันที
    this.currentUrl = this.router.url.split('/')[1];

    this.sidebarList = this.page.commonList
    console.log("sidebarList: ", this.sidebarList , this.currentUrl);
  }

  toggleSidebar() {
    this.showSidebar = false;
    this.showSidebarChange.emit(this.showSidebar);
    console.log("Status Sidebar: ", this.showSidebar);
  }
  toggleCategory(category : string){
    const check = this.isOpenCategory.find(item => item.category === category)
    if(check) {
      this.isOpenCategory = this.isOpenCategory.filter(item => item.category !== category);     
    } else {
      this.isOpenCategory.push({category : category, open : true});
    }
  }
  checkOpenCategory(category : string){
    const check = this.isOpenCategory.find(item => item.category === category)
    return check ? check.open : false
  }
  getURL(): boolean {
    const showIn = ['/home','/ev-charger','/parking-center','/profile']; 
    return showIn.some((path) => this.currentUrl.startsWith(path));
  }
  onClickNavigateTo(path: string): void {
    if (path) {
      this.router.navigate([path]);
      this.showSidebar = false;
      this.showSidebarChange.emit(this.showSidebar);
    }
  }

}
